import React, { useContext } from 'react';
import { Text } from '@fluentui/react';
import { ThemeContext } from '../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../Common/util/localStorageUtils';
import { EnvironmentDataChannel } from '../models/EnvironmentModels';
import { ActiveChannelCard } from './ActiveChannelCard';

interface ActiveChannelsListProps {
    channels: EnvironmentDataChannel[];
}

export const ActiveChannelsList: React.FC<ActiveChannelsListProps> = ({ channels }) => {
const themeContext = useContext(ThemeContext);
const theme = getThemeFromString(themeContext.themeName);

    if (channels.length === 0) {
        return (
            <Text variant="small" styles={{ root: { fontStyle: 'italic', color: theme.palette.neutralSecondary } }}>
                No channels configured
            </Text>
        );
    }

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '12px' }}>
            {channels.map((channel, index) => (
                <ActiveChannelCard key={index} channel={channel} />
            ))}
        </div>
    );
};
